import VueLogger from 'vuejs-logger';
import Vue from "vue";
const isProduction = process.env.NODE_ENV === 'production';
const logInProduction = false;

const options = {
    isEnabled: true,
    logLevel : isProduction && !logInProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};

export function registerLogger(Vue){
    Vue.use(VueLogger, options);
}

export function logInfo(...objects){
    Vue.$log.info(...objects)
}
